import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
declare const require: any;
const jsPDF = require("jspdf");
require("jspdf-autotable");
import * as xlsx from "xlsx-js-style";
const FileSaver = require("file-saver");

@Injectable({
    providedIn: "root",
})
export class ActivityService {
    constructor() {}

    viewSelected = new BehaviorSubject<{ type: string; date: Date }>({ type: "day", date: new Date() });
    seeAll = false;
    userId:number;
    tenantId:number;
    getMonthViewSelectedAsObs(): Observable<{ type: string; date: Date }> {
        return this.viewSelected.asObservable();
    }

    selectView(view: string, date?: Date): void {
        if (view === "day" && date !== undefined) this.viewSelected.next({ type: view, date: date });
        if (view !== "day") this.viewSelected.next({ type: view, date: date });
    }

    setZeroTimeForLocalDate(date: Date): Date {
        date.setHours(0, 0, 0, 0);
        return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    }

    // get local js date from a UTC datetime object
    getLocalJsDate(date: DateTime): Date {
        let jsDate = new Date(
            `${date?.year}-${date?.month < 10 ? "0" + date?.month : date?.month}-${date?.day < 10 ? "0" + date?.day : date?.day}T${
                date?.hour < 10 ? "0" + date?.hour : date?.hour
            }:${date?.minute < 10 ? "0" + date?.minute : date?.minute}:${date?.second < 10 ? "0" + date?.second : date?.second}`
        );
        return new Date(jsDate.getTime() - jsDate.getTimezoneOffset() * 60 * 1000);
    }

    timestampToMinutes(timestamp: string): number {
        if (!timestamp) return 0;
        return parseInt(timestamp.split(":")[0]) * 60 + parseInt(timestamp.split(":")[1]);
    }

    minutesToTimestamp(minutes: number): string {
        let hours = Math.floor(minutes / 60);
        let min = minutes % 60;
        if (isNaN(hours) || isNaN(min)) return "--:--";
        return `${hours < 10 ? "0" + hours : hours}:${min < 10 ? "0" + min : min}`;
    }

    getHoursAndMin(timespan: string) {
        if (!timespan) return "0 hrs 0 min";
        let hours = parseInt(timespan.split(":")[0]);
        let min = parseInt(timespan.split(":")[1]);
        return `${hours} hrs ${min} min`;
    }

    exportPdf(exportColumns: any[], data: any, name: string, pdfTitle: string) {
        const doc = new jsPDF.default("l", "pt");
        doc.setTextColor(100);
        doc.text(40, 40, pdfTitle);
        const tableData = data.map((item) => exportColumns.map((column) => item[column.dataKey]));
        doc.autoTable({
            head: [exportColumns.map((column) => column.title)],
            body: tableData,
            startY: 60,
        });
        doc.save(`${name}.pdf`);
    }

    exportExcel(columns: string[][], data: any[][], sheetName: string, fileName: string) {
        const workbook: xlsx.WorkBook = xlsx.utils.book_new();

       
        const worksheet = xlsx.utils.aoa_to_sheet([]);
        xlsx.utils.sheet_add_aoa(worksheet, [[fileName]], { origin: "A1" });
        xlsx.utils.sheet_add_aoa(worksheet, columns, {
            origin: "A2",
        });
        xlsx.utils.sheet_add_aoa(worksheet, data, {
            origin: "A3",
        });
           // Merge and center cells A1 to F1
worksheet["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }];
        this.styleExcel(worksheet);
        xlsx.utils.book_append_sheet(workbook, worksheet, sheetName);
        const excelBuffer: any = xlsx.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });
        this.saveAsExcelFile(excelBuffer, fileName);
    }

    styleExcel(ws: xlsx.WorkSheet) {
        ws["!cols"] = new Array(4).fill({ width: 20 });
        for (let i in ws) {
            if (typeof ws[i] != "object") continue;
            let cell = xlsx.utils.decode_cell(i);

            ws[i].s = {
                font: {
                    name: "Calibri",
                    sz: 11,
                    color: { rgb: "000000" },
                },
            };

            ws[i].s.border = {
                top: {
                    style: "thin",
                    color: { rgb: "000000" },
                },
                bottom: {
                    style: "thin",
                    color: { rgb: "000000" },
                },
                left: {
                    style: "thin",
                    color: { rgb: "000000" },
                },
                right: {
                    style: "thin",
                    color: { rgb: "000000" },
                },
            };

            if (cell.r == 1) {
                ws[i].s.font.bold = true;
                ws[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "DDDDDD" },
                };
            }
            if (cell.r == 0) {
                ws[i].s.font.bold = true;
                ws[i].s.font.underline = true; 
                ws[i].s.font.sz = 12;
                ws[i].s.fill = {
                    patternType: "solid",
                    fgColor: { rgb: "FFFFFF" },

                };
                ws[i].s.alignment = {
                    vertical: "center",
                        horizontal: "center",
                        wrapText: '1',
                }
            }
        }
    }

    saveAsExcelFile(buffer: any, fileName: string): void {
        let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data: Blob = new Blob([buffer], {
            type: EXCEL_TYPE,
        });
        FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
    }
}
